import {
  SET_CHO_VAY_EDIT,
  SET_THUOCTINH_TAISAN_TM_CAM_DO,
  SET_LIST_TAI_SAN_CAM_CO_TM_CAM_DO,
  SET_CONFIG_TM_CAM_DO,
  SET_TAI_SAN_CAM_CO_TM_CAM_DO,
  GET_TAI_SAN_THEO_CHO_VAY_TMCD,
  GET_TAI_SAN_THUOC_TINH_TMCD,
  SET_LIST_LOAI_TAI_SAN_TM_CAM_DO,
  GET_LOAI_TAI_SAN_TMCD,
  SHOW_FORM_CAM_DO,
  GET_CONFIG_SYS_TMCD,
  SET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN,
  POST_CAM_DO,
  POST_CAM_DO_SUCCESS,
  POST_CAM_DO_FAILURE,
  CHECK_EDIT_CHO_VAY,
  CHECK_EDIT_CUSTOMER,
  SET_ENABLE_EDIT_CHO_VAY,
  SET_ENABLE_EDIT_CUSTOMER,
} from "actions/ThemMoiCamDo/actionTypes";

const initialState = {
  choVayEdit: {
    NgayVay: new Date(),
    NgayTraGoc: new Date(),
    CustomerId: 0,
    IsEditChoVay: true,
    IsEditCustomer: true,
  },
  ThuocTinhTaiSan: [],
  TaiSanCamCo: [],
  ListTaiSanCamCo: [],
  ConfigTMCD: {},
  taiSanTheoChoVayLoaded: false,
  ListLoaiTaiSan: [],
  isShowFormCamDo: false,
  postCamDoLoading: false,
  postCamDoReturn: false,
};

const setChoVayEdit = (state, action) => ({
  ...state,
  choVayEdit: action.payload,
});
const setTaiSanCamCo = (state, action) => ({
  ...state,
  TaiSanCamCo: action.payload,
});
const setThuocTinhTaiSan = (state, action) => {
  return {
    ...state,
    ThuocTinhTaiSan: action.payload,
  };
};

const setListTaiSanCamCo = (state, action) => ({
  ...state,
  ListTaiSanCamCo: action.payload,
});

const setConfig = (state, action) => {
  let config = action.payload;
  let choVayEdit = state.choVayEdit;
  if (!choVayEdit.ChoVayId) {
    choVayEdit.TypePaid = config._selectKyDongLai;
    let _selectKyDongLai = parseFloat(action.payload._selectKyDongLai);
    if (_selectKyDongLai === 1) {
      choVayEdit.KieuLaiSuat = config._selectKyLaiSuatNgay;
      choVayEdit.LaiSuat = config._laiSuatTinChapCamDoNgay;
    } else if (_selectKyDongLai === 2) {
      choVayEdit.LaiSuat = config._laiSuatTinChapCamDoThang;
      choVayEdit.KieuLaiSuat = config._selectKyLaiSuatThang;
    } else if (_selectKyDongLai === 4) {
      //Tuần
      choVayEdit.KieuLaiSuat = config._selectKyLaiSuatTuan;
      choVayEdit.LaiSuat = config._laiSuatTinChapCamDoTuan;
    } else {
      choVayEdit.LaiSuat = "";
    }
    choVayEdit.CountTypePaid = config._kyDongLaiTinChapCamDo;
    choVayEdit.BeforeAfter =
      action.payload._beforeAfterTinChapCamDo === "1" ? "2" : "1";
    if (config.IsSoNgayTatToan)
      choVayEdit.SoNgayToiThieu = config.SoNgayMacDinhTatToan;
    else choVayEdit.SoNgayToiThieu = 0;
  }
  return {
    ...state,
    choVayEdit,
    ConfigTMCD: action.payload,
  };
};
const setListLoaiTaiSan = (state, action) => ({
  ...state,
  ListLoaiTaiSan: action.payload,
});
const setListLoaiTaiSanReloadTMLTS = (state, action) => {
  let TaiSanCamCo = state.TaiSanCamCo;
  if (action.payload) {
    TaiSanCamCo.LoaiTaiSan = action.payload[action.payload.length - 1].value;
  }
  return {
    ...state,
    TaiSanCamCo,
    ListLoaiTaiSan: action.payload,
  };
};
const getTaiSanTheoChoVayTMCD = (state, action) => ({
  ...state,
  taiSanTheoChoVayLoaded: true,
});
const getThuocTinhTaiSanTMCD = (state, action) => ({
  ...state,
});
const getLoaiTaiSanTMCD = (state, action) => ({
  ...state,
});
const getLoaiTaiSanTMCDReloadTMLTS = (state, action) => ({
  ...state,
});
const showFormCamDo = (state, action) => {
  let choVay = {
    NgayVay: new Date(),
    CustomerId: 0,
  };
  if (action.payload && action.payload.ChoVayId) {
    choVay = action.payload;
  }
  choVay.IsEditChoVay = true;
  choVay.IsEditCustomer = true;
  choVay.ChiPhiVay = choVay.ChiPhiVay
    ? parseFloat(choVay.ChiPhiVay.toFixed(2))
    : 0;
  choVay.PhiThanhToanSom = choVay.PhiThanhToanSom
    ? parseFloat(choVay.PhiThanhToanSom.toFixed(2))
    : 0;
  choVay.PhiBaoHiem = choVay.PhiBaoHiem
    ? parseFloat(choVay.PhiBaoHiem.toFixed(2))
    : 0;
  return {
    ...state,
    choVayEdit: choVay,
    isShowFormCamDo: !state.isShowFormCamDo,
  };
};
const getConfigSysTMCD = (state, action) => ({
  ...state,
});

const postCamDo = (state, action) => ({
  ...state,
  postCamDoLoading: true,
  postCamDoReturn: false,
  dataPost: action.dataPost,
});

const postCamDoSuccess = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.ChoVayId = action.payload.ChoVayId;
  choVayEdit.showButtonIn = true;
  choVayEdit.ThuChiId = action.payload.ThuChiId;
  choVayEdit.ImgDinhKemSave = action.payload.ImgDinhKem;
  choVayEdit.lstImgTaiSanSave = action.payload.lstImgTaiSan;
  choVayEdit.ImgCusNewSave = action.payload.ImgKhachHang;
  if (parseFloat(choVayEdit.BeforeAfter) === 2) {
    choVayEdit.showButtonInPhieuThu = true;
  }
  return {
    ...state,
    postCamDoLoading: false,
    postCamDoReturn: true,
    choVayEdit,
  };
};

const postCamDoFailed = (state, action) => ({
  ...state,
  postCamDoLoading: false,
  postCamDoReturn: false,
});
const checkEditChoVay = (state, action) => ({
  ...state,
});
const setEnableEditChoVay = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.IsEditChoVay = action.payload.IsEditChoVay;
  choVayEdit.IsEditCustomer = action.payload.IsEditCustomer;
  return {
    ...state,
    choVayEdit,
  };
};
const checkEditCustomer = (state, action) => ({
  ...state,
});
const setEnableEditCustomer = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.IsEditCustomer = action.payload.IsEditCustomer;
  return {
    ...state,
    choVayEdit,
  };
};
const themMoiCamDoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHO_VAY_EDIT:
      return setChoVayEdit(state, action);
    case SET_TAI_SAN_CAM_CO_TM_CAM_DO:
      return setTaiSanCamCo(state, action);
    case SET_THUOCTINH_TAISAN_TM_CAM_DO:
      return setThuocTinhTaiSan(state, action);
    case SET_LIST_TAI_SAN_CAM_CO_TM_CAM_DO:
      return setListTaiSanCamCo(state, action);
    case SET_CONFIG_TM_CAM_DO:
      return setConfig(state, action);
    case GET_TAI_SAN_THEO_CHO_VAY_TMCD:
      return getTaiSanTheoChoVayTMCD(state, action);
    case GET_TAI_SAN_THUOC_TINH_TMCD:
      return getThuocTinhTaiSanTMCD(state, action);
    case SET_LIST_LOAI_TAI_SAN_TM_CAM_DO:
      return setListLoaiTaiSan(state, action);
    case SET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN:
      return setListLoaiTaiSanReloadTMLTS(state, action);
    case GET_LOAI_TAI_SAN_TMCD:
      return getLoaiTaiSanTMCD(state, action);
    case SHOW_FORM_CAM_DO:
      return showFormCamDo(state, action);
    case GET_CONFIG_SYS_TMCD:
      return getConfigSysTMCD(state, action);
    case GET_LIST_TAI_SAN_CAM_CO_TM_LOAI_TAISAN:
      return getLoaiTaiSanTMCDReloadTMLTS(state, action);
    case POST_CAM_DO:
      return postCamDo(state, action);
    case POST_CAM_DO_SUCCESS:
      return postCamDoSuccess(state, action);
    case POST_CAM_DO_FAILURE:
      return postCamDoFailed(state, action);
    case CHECK_EDIT_CHO_VAY:
      return checkEditChoVay(state, action);
    case SET_ENABLE_EDIT_CHO_VAY:
      return setEnableEditChoVay(state, action);
    case CHECK_EDIT_CUSTOMER:
      return checkEditCustomer(state, action);
    case SET_ENABLE_EDIT_CUSTOMER:
      return setEnableEditCustomer(state, action);
    default:
      return state;
  }
};
export default themMoiCamDoReducer;
